import { Button } from '@finn/design-system/atoms/button';
import { Download } from '@finn/design-system/icons/download';
import {
  DataModule,
  DataModuleBody,
  DataModuleCell,
  DataModuleHeader,
  DataModuleRow,
  DataModuleTitle,
} from '@finn/design-system/modules/DataModule';
import { App, trackEvent, useCurrentApp } from '@finn/ui-utils';

import { Skeleton } from '../components/Skeleton';

type DocumentsListProps = {
  documents: {
    documentType: string;
    name: string;
    url?: string;
  }[];
  documentTypes?: {
    [key: string]: string;
  };
  title: string;
  isLoading?: boolean;
};

export const DocumentsList = ({
  documents,
  documentTypes,
  title,
  isLoading,
}: DocumentsListProps) => {
  const app = useCurrentApp();

  return (
    <DataModule size={app === App.B2B ? 'small' : 'large'}>
      <DataModuleHeader className="flex flex-row">
        <DataModuleTitle>{title}</DataModuleTitle>
      </DataModuleHeader>
      <Skeleton
        height="90px"
        fullWidth
        numFields={3}
        loading={Boolean(isLoading)}
      >
        <DataModuleBody>
          {documents?.map((doc) => (
            <DataModuleRow key={doc.url} asChild>
              <Button
                href={doc.url}
                className="w-full p-0 before:hidden after:hidden"
                contentClassName="w-full justify-between"
                variant="ghost"
                target="_blank"
                rel="noreferrer"
                download
                onClick={() =>
                  trackEvent('Document Opened', {
                    document_type: doc.documentType,
                  })
                }
              >
                <DataModuleCell>
                  {documentTypes?.[doc.documentType]}
                </DataModuleCell>
                <DataModuleCell>
                  <Download />
                </DataModuleCell>
              </Button>
            </DataModuleRow>
          ))}
        </DataModuleBody>
      </Skeleton>
    </DataModule>
  );
};
